import { createRouter, createWebHashHistory } from 'vue-router'
import Chat from '../../pages/chat/index.vue'
import WalkmanPlayer from '../../pages/walkman/index.vue'
// import WordsPlayer from '../../pages/walkman/wordsPlayer.vue'
import AiTeacher from '../../pages/aiTeacher/index.vue'
import AiDictationRes from '../../pages/aiDictationModule/index.vue'
import PublicPage from '../../pages/publicPage/index.vue'
import QuickQA from '../../pages/quickQA/index.vue'
import WordTestData from '../../pages/wordTestData/index.vue'
import FirstExamIndex from '../../pages/firstExam/index.vue'
import FirstReport from '../../pages/firstExam/firstReport.vue'
import Exam from '../../pages/firstExam/exam.vue'
const routes = [
  {
    path: '/',
    redirect: '/publicPage/index' // 默认跳转到 中转 页面
  },
  {
    path: '/chat/index',
    name: 'Chat',
    component: Chat
  },
  {
    path: '/walkman/index',
    name: 'WalkmanPlayer',
    component: WalkmanPlayer
  },
  {
    path: '/aiTeacher/index',
    name: 'AiTeacher',
    component: AiTeacher
  },
  {
    path: '/aiDictationModule/index',
    name: 'AiDictationModule',
    component: AiDictationRes
  },
  {
    path: '/publicPage/index',
    name: 'PublicPage',
    component: PublicPage
  },
  {
    path: '/quickQA/index',
    name: 'QuickQA',
    component: QuickQA
  },
  {
    path: '/wordTestData/index',
    name: 'WordTestData',
    component: WordTestData
  },
  {
    path: '/firstExam/index',
    name: 'FirstExamIndex',
    component: FirstExamIndex
  },
  {
    path: '/firstExam/firstReport',
    name: 'FirstReport',
    component: FirstReport
  },
  {
    path: '/firstExam',
    redirect: '/firstExam/index'
  },
  {
    path: '/firstExam/exam',
    name: 'Exam',
    component: Exam,
    meta: { title: '测评页面' }
  },
  {
    path: '/firstReport/index',
    redirect: '/firstExam/firstReport'
  },
]

const router = createRouter({
  // 使用 hash 模式，适配 file:// 协议
  history: createWebHashHistory(),
  routes
})

export default router

